exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".switch-button-wrapper .switch-wrapper {\n  max-width: unset !important; }\n\n.holiday-schedule-wrapper {\n  margin-top: 10px !important; }\n", ""]);

